import "../../../../ambassador-docs/docs/1.6/topics/install/index.less";
import * as React from 'react';
export default {
  React
};